const permissions = {
	ChatOperations: {
		action_manage: 'ChatOperations.action_manage',
	},
	VideoCallsOperations: {
		action_manage: 'VideoCallsOperations.action_manage',
	},
	EducationOperations: {
		action_manage: 'EducationOperations.action_manage',
	},
	AnalyticsModulesOperations: {
		action_manage_dashboard: 'AnalyticsModulesOperations.action_manage_dashboard',
		action_manage_report_templates: 'AnalyticsModulesOperations.action_manage_report_templates',
		action_manage_report_designer: 'AnalyticsModulesOperations.action_manage_report_designer',
		action_manage_cartograms: 'AnalyticsModulesOperations.action_manage_cartograms',
	},
	AdminOperations: {
		role_admin: 'AdminOperations.role_admin',
		action_editKnowledgeBase: 'AdminOperations.action_editKnowledgeBase',
	},
	AdminKbOperations: {
		action_editKnowledgeBase: 'AdminKbOperations.action_editKnowledgeBase',
	},
	AdminGrantOperations: {
		view_permissions: 'AdminGrantOperations.view_permissions',
		action_manage_access: 'AdminGrantOperations.action_manage_access',
	},
	UserOperations: {
		action_clientPartViewKnowledgeBase: 'UserOperations.action_clientPartViewKnowledgeBase',
		action_clientPartEditKnowledgeBase: 'UserOperations.action_clientPartEditKnowledgeBase',
	},
	CallOperations: {
		record_listening: 'CallOperations.record_listening',
		action_workPbx: 'CallOperations.action_workPbx',
	},
	CustomerOperations: {
		action_createCustomer: 'CustomerOperations.action_createCustomer',
		action_editCustomer: 'CustomerOperations.action_editCustomer',
		view_customer: 'CustomerOperations.view_customer',
		view_contactPersons: 'CustomerOperations.view_contactPersons',
		view_contacts: 'CustomerOperations.view_contacts',
		action_manageContactPersons: 'CustomerOperations.action_manageContactPersons',
		view_addresses: 'CustomerOperations.view_addresses',
		action_manageAddresses: 'CustomerOperations.action_manageAddresses',
		action_unlinkContactPersons: 'CustomerOperations.action_unlinkContactPersons',
		// Backward-compat alias (historical typo in key casing).
		view_Item: 'CustomerOperations.view_item',
		view_item: 'CustomerOperations.view_item',
	},
	SearchOperations: {
		search_contactPersons: 'SearchOperations.search_contactPersons',
		search_customer: 'SearchOperations.search_customer',
		search_appeal: 'SearchOperations.search_appeal',
	},
	FileOperations: {
		generate_file: 'FileOperations.generate_file',
	},
	AppealOperations: {
		action_createAppeal: 'AppealOperations.action_createAppeal',
		action_createAppealRepeat: 'AppealOperations.action_createAppealRepeat',
		action_createAppealDuplet: 'AppealOperations.action_createAppealDuplet',
	},
	AiAgentAccessOperations: {
		action_manage: 'AiAgentAccessOperations.action_manage',
	},
	DashboardOperations: {
		dashboard_workWithDashboard: 'DashboardOperations.dashboard_workWithDashboard',
	},
	FilterOperations: {
		create_public_filter: 'FilterOperations.create_public_filter',
	},
	InteractionOperations: {
		action_AddAssessments: 'InteractionOperations.action_AddAssessments',
	},
	OrderOperations: {
		view_order: 'OrderOperations.view_order',
		action_createOrder: 'OrderOperations.action_createOrder',
	},
	InterviewRecordOperations: {
		action_manage: 'InterviewRecordOperations.action_manage',
	},
	InternalChatOperations: {
		action_manage: 'InternalChatOperations.action_manage',
	},
};

export function checkPermissions(permission) {
	let operations;

	// Lazy-load store to avoid circular deps during bootstrap/tests.
	// Webpack will still bundle this correctly, but it won't execute until called.
	try {
		// eslint-disable-next-line global-require
		const storeModule = require('../store');
		const store = storeModule?.default || storeModule;
		operations = store?.getState?.()?.user?.operations;
	} catch (e) {
		operations = undefined;
	}

	if (!permission || !Array.isArray(operations)) {
		return false;
	}

	return operations.includes(permission);
}

export default permissions;
